import { forwardRef } from "react";
import AppFormModal from "@richbeauty/core/AppFormModal";
import IntlMessages from "@richbeauty/utility/IntlMessages";
import useImportCustomerLeadFileFieldConfig from "./useImportCustomerLeadFileFieldConfig";
import { revalidateCustomerLeads } from "@richbeauty/utility/helper/cacheRevalidator";
import useImportCustomerLead from "hooks/apis/customerLeads/useCustomerLeadImport";

const ImportCustomerLeadModal = forwardRef((_, ref) => {
  const { trigger, isMutating } = useImportCustomerLead();
  const importFieldConfig = useImportCustomerLeadFileFieldConfig();
  const onFinish = (values) => {
    try {
      trigger({ file: values.file[0].originFileObj });
      revalidateCustomerLeads();
      ref.current?.closeModal();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <AppFormModal
      ref={ref}
      onFinish={onFinish}
      layout={"vertical"}
      fieldsConfig={importFieldConfig}
      isSubmitting={isMutating}
      title={<IntlMessages id="app.user.importUser" />}
    />
  );
});

export default ImportCustomerLeadModal;
